import React from "react";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarTableErrorMessage from "shared/components/pillar-table/error/PillarTableErrorMessage";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";

/**
 * Shown in the failed row, in one cell spanning the Edit and Delete columns,
 * when `handleInlineEdit` or `handleInlineDelete` threw. Dismiss puts the row
 * back: a failed edit returns to editing with what was typed, a failed delete
 * returns to the Delete button.
 */
const PillarTableRowActionError = () => {
  const { testidTable, handleInlineEdit, handleInlineDelete } =
    usePillarTableContext();
  const { rowActionFailure, setRowActionFailure, setInlineEditMode } =
    usePillarTableRowContext();

  if (!rowActionFailure) {
    return <></>;
  }

  const testid = `${testidTable}-row-action-error`;
  const actionColumnCount =
    Number(Boolean(handleInlineEdit)) + Number(Boolean(handleInlineDelete));

  return (
    <td
      colSpan={actionColumnCount}
      className="pillartable-table-cell-general"
      onClick={(event) => event.stopPropagation()}
    >
      {/* `w-0 min-w-full` gives the message no width of its own, so it wraps
          within the width the action columns already have instead of widening them. */}
      <div
        className="w-0 min-w-full whitespace-normal"
        role="alert"
        data-testid={testid}
      >
        <PillarTableErrorMessage
          error={rowActionFailure.error}
          testid={testid}
          compact
        >
          <PillarForm.Button
            className="button-small-neutral-filled"
            testid={`${testid}-dismiss`}
            onClick={(event) => {
              event.stopPropagation();
              if (rowActionFailure.action === "delete") {
                setInlineEditMode("none");
              }
              setRowActionFailure(undefined);
            }}
          >
            Dismiss
          </PillarForm.Button>
        </PillarTableErrorMessage>
      </div>
    </td>
  );
};

export default PillarTableRowActionError;
